import { useSelector } from "react-redux";
import {
  globalDataSelector,
} from "../../../redux/slices/globalDataSlice";
import { useSearchParams } from "react-router-dom";
import useGetSearchParams from "../../../hooks/useGetSearchParams";
import useSetSearchParams from "../../../hooks/useSetSearchParams";
import React, {useEffect, useRef} from "react";
import { useDebounce } from "../../../hooks/useDebounce";
import {
  search
} from "../../Authorized/Statistics/IOS/IOSClicksStats/IOSClicksStats";
import s from "./newStatistics.module.scss";
import SvgSelector from "../../../components/SvgSelector/SvgSelector";
import { useTranslation } from "react-i18next";
import Header from "../../../components/Partials/Header/Header";
import GradientBorder from "../../../components/GradientBorder/GradientBorder";
import IOSGeoAppStatistics from "./Tabs/IOSGeoAppStatistics/IOSGeoAppStatistics";
import UsersStatistics from "./Tabs/UsersStatistics/UsersStatistics";
import FinanceStatistics from "./Tabs/FinanceStatistics/FinanceStatistics";
import {fetchGeoStats} from "../../../redux/slices/statisticsSlice";
import GeoStatistics from "./Tabs/GeoStatistics/GeoStatistics";
import IOSUsersStatistics from "./Tabs/IOSUsersStatistics/IOSUsersStatistics";
import AppStatistics from "./Tabs/AppStatistics/AppStatistics";

const GEO_APP = 'geo+app'
const USERS = 'users'
const USERS_IOS = 'users_ios'
const FINANCE = 'finance'
const GEO = 'geo'
const APP = 'app'

export const statisticsTabList = [
  {
    name: "GEO+APP (IOS)",
    icon: "geo-app-stats",
    value: GEO_APP,
  },
  {
    name: "users_ios",
    icon: "users-stats",
    value: USERS_IOS,
  },
  {
    name: "geo_common",
    icon: "geo-app-stats",
    value: GEO,
  },
  {
    name: "users_common",
    icon: "users-stats",
    value: USERS,
  },
  {
    name: "app_common_statistics",
    icon: "app-select-icon",
    value: APP,
  },
  {
    name: "finance_common",
    icon: "domain-select-icon",
    value: FINANCE,
  },
];

const NewStatistics = () => {
  const underlineRef = useRef(null);

  const { isCollapsedSidebar } =
    useSelector(globalDataSelector);

  const [searchParams, setSearchParams] = useSearchParams();

  const { search: searchValue, content: contentValue } = useGetSearchParams();

  const updateSearchParams = useSetSearchParams(setSearchParams);

  const { t, i18n } = useTranslation();

  const currentTab = (() => {

    if (statisticsTabList.find(item => item.value === contentValue)) {
      return contentValue;
    } else {
      return statisticsTabList[0].value;
    }
  })();

  const [inputSearchValue, setInputSearchValue] = useDebounce((value) => {
    if (value) {
      updateSearchParams(search, value);
    } else {
      updateSearchParams(search, value, true);
    }
  }, 600);

  useEffect(() => {
    const activeBtn = document.querySelector(`.${s.active}`);
    if (activeBtn && underlineRef.current) {
      const { left, width } = activeBtn.getBoundingClientRect();
      const parentLeft = activeBtn.parentElement.getBoundingClientRect().left;
      const scrollLeft = activeBtn.parentElement.scrollLeft; // Додаємо врахування скролу

      underlineRef.current.style.width = `${width}px`;
      underlineRef.current.style.transform = `translateX(${left - parentLeft + scrollLeft}px)`;
    }
  }, [currentTab, i18n.language]);

  useEffect(() => {
    if (!searchValue) {
      setInputSearchValue("");
    } else {
      setInputSearchValue(searchValue);
    }
  }, [searchParams]);

  return (
    <div
      className={`${s.balancesWrapper} ${isCollapsedSidebar === "true" ? s.collapsedSidebar : ""}`}
    >

      <Header
          searchValue={inputSearchValue}
          setSearchValue={setInputSearchValue}
          isSearch
      />
      <div className={s.pageContent}>
        <div className={s.switchPageContentContainer}>
          <div className={s.buttonsContainer}>
            {statisticsTabList.map(({name, value, icon}) => (
                <button
                    key={name}
                    onClick={() => setSearchParams({ content: value })}
                    className={`${s.pageBtn} ${currentTab === value ? s.active : ""}`}
                >
                  <SvgSelector id={icon}/>
                  {t(name)}
                </button>
            ))}

            <div className={s.underline} ref={underlineRef}></div>
          </div>
        </div>
        <GradientBorder className={s.gradientBorderCustom}/>
        {currentTab === USERS && <IOSUsersStatistics/>}
        {currentTab === GEO && <GeoStatistics/>}
        {currentTab === GEO_APP && <IOSGeoAppStatistics/>}
        {currentTab === FINANCE && <FinanceStatistics/>}
        {currentTab === USERS_IOS && <UsersStatistics/>}
        {currentTab === APP && <AppStatistics/>}
      </div>
    </div>
  );
};

export default NewStatistics;
